import { render, staticRenderFns } from "./CommentWork.vue?vue&type=template&id=50dd0123&scoped=true"
import script from "./CommentWork.vue?vue&type=script&lang=js"
export * from "./CommentWork.vue?vue&type=script&lang=js"
import style0 from "./CommentWork.vue?vue&type=style&index=0&id=50dd0123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd0123",
  null
  
)

export default component.exports